// extracted by mini-css-extract-plugin
export default {"confirmModal":"ConfirmModal_confirmModal__YfbWv","labels":"ConfirmModal_labels__lYSK9","buttons":"ConfirmModal_buttons__SR32w","button":"ConfirmModal_button__nteSB"};